import { useEffect, useState } from "react";
import { STATS, scrollTo } from "../data/constants";
import { IconArrow } from "./icons";

const ROLES = ["full-stack developer", "cloud practitioner", "Java · React · AWS"];

/* Editor-style typing: types a phrase, holds, deletes, moves to the next. */
function useTypedRole() {
  const [text, setText] = useState(ROLES[0]);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    let i = 0, char = 0, deleting = false, timer;

    const tick = () => {
      const word = ROLES[i];
      char += deleting ? -1 : 1;
      setText(word.slice(0, char));

      let delay = deleting ? 34 : 62;
      if (!deleting && char === word.length) { deleting = true; delay = 1900; }
      else if (deleting && char === 0)       { deleting = false; i = (i + 1) % ROLES.length; delay = 320; }

      timer = setTimeout(tick, delay);
    };

    timer = setTimeout(tick, 1400);
    return () => clearTimeout(timer);
  }, []);

  return text;
}

export default function Hero() {
  const role = useTypedRole();

  return (
    <section id="hero" className="sec" style={{ paddingTop: 64 }}>
      <p className="sec-marker reveal">{"<!-- entry point -->"}</p>

      <h1 className="display reveal d1">
        Backend depth,<br />
        <span className="ghost">frontend care.</span>
      </h1>

      <p className="reveal d2" style={{ marginTop: 26, fontSize: 13, color: "var(--fg-dim)" }}>
        <span className="t-key">const</span> <span className="t-fn">nisarg</span> ={" "}
        <span className="t-str">"{role}"</span>
        <span className="caret" />
      </p>

      <p className="prose reveal d3" style={{ marginTop: 22 }}>
        Software engineer in Toronto. I build full-stack applications end to end — data model
        through deployment — and I would rather ship something small that holds up than something
        large that needs a rewrite.
      </p>

      <div className="reveal d4" style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 34 }}>
        <button className="btn btn-accent btn-block-xs" onClick={() => scrollTo("projects")}>
          View work <IconArrow width={13} height={13} />
        </button>
        <button className="btn btn-block-xs" onClick={() => scrollTo("contact")}>
          Get in touch
        </button>
      </div>

      <dl className="reveal d5" style={{
        display: "flex", flexWrap: "wrap", gap: 46,
        marginTop: 58, paddingTop: 30, borderTop: "1px solid var(--line)",
      }}>
        {STATS.map(([value, label]) => (
          <div key={label}>
            <dt style={{
              fontFamily: "'Space Grotesk', sans-serif", fontSize: 30,
              fontWeight: 600, letterSpacing: "-.03em", color: "var(--fg)",
            }}>
              {value}
            </dt>
            <dd style={{ fontSize: 10.5, color: "var(--fg-mute)", marginTop: 4 }}>{label}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
